import type { StringDictionary } from '../types/types';

export const PAGE_URLS = {
  LANDING: '/',
  IN_APP: '/in-app',
  PARTNER: '/partner',
  B2B_MARKETING_ASSESSMENT: '/b2b',
  ASSESSMENT: '/assessment',
  QUESTIONS: '/assessment/questions',
  PRE_RESULTS_ANIMATION: '/well-done',
  RESULTS: '/results',
  SIGNUP: '/signup',
  SUCCESS: '/success',
  ELIGIBILITY_REVIEW: '/review',
  UNDER_CONSTRUCTION: '/under-construction',
  WAITING_LIST: '/waiting-list',
  ERROR: '/error',
  CATCH_ALL: '/*',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_AND_CONDITIONS: '/terms-conditions',
};

export const DEFAULT_MIN_PASSWORD_LENGTH = 9;
export const MAX_PASSWORD_LENGTH = 99;

export const STATES: StringDictionary = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FM: 'Federated States Of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const USER_EMAIL_STATUS_RES: StringDictionary = {
  EXISTS: 'user-exists',
  NOT_VERIFIED: 'email-not-verified',
  NOT_FOUND: 'user-not-found',
  NOT_INITIALIZED: 'user-not-initialized',
  INVALID_EMAIL: 'invalid-email',
  UNDEFINED: 'undefined',
};
export const APPLE_STORE_LINK =
  'https://apps.apple.com/us/app/pivot-make-impactful-changes/id1236893700?ppid=88c10463-75bf-42d4-acca-231b110719ce';
export const APPLE_STORE_DEEPLINK =
  'itms-apps://itunes.apple.com/app/id1236893700';
export const PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=com.carrot.pivot&listing=flex';
